module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!builtin:swc-loader??ruleSet[1].rules[0].use[0]!./home.jsx"));
	});
}